import { createContext, useContext } from 'react';

interface BreadcrumItem {
  title: string;
  onClick?: () => void;
  onRightClick?: () => void;
  link?: string;
}

export type BreadcrumContextType = {
  items: BreadcrumItem[];
};

export const BreadcrumContext = createContext<BreadcrumContextType>({
  items: [],
});

export const useBreadcrum = () => useContext(BreadcrumContext);
